import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import {
  loadRecentSearches,
  MAX_RECENT_SEARCHES,
  saveRecentSearches,
} from '../utils/searchHistory';

const SearchContext = createContext();

export const useSearch = () => {
  const context = useContext(SearchContext);
  if (!context) {
    throw new Error('useSearch must be used within a SearchProvider');
  }
  return context;
};

export const SearchProvider = ({ children }) => {
  const [searchTerm, setSearchTerm] = useState('');
  /** Alleen gezet op route /magazijn: 'pick' | 'search' | 'retouren' voor navbar-placeholder. */
  const [magazijnSubTab, setMagazijnSubTab] = useState(null);
  const [recentSearches, setRecentSearches] = useState(() => loadRecentSearches());

  const commitRecentSearch = useCallback((term) => {
    const t = String(term || '').trim();
    if (t.length < 2) return;
    setRecentSearches((prev) => {
      const next = [t, ...prev.filter((x) => x.toLowerCase() !== t.toLowerCase())].slice(
        0,
        MAX_RECENT_SEARCHES
      );
      saveRecentSearches(next);
      return next;
    });
  }, []);

  /** Onthoud stabiele zoekterm na korte pauze (alle pagina's). */
  useEffect(() => {
    const t = searchTerm.trim();
    if (t.length < 2) return undefined;
    const id = window.setTimeout(() => commitRecentSearch(t), 1200);
    return () => window.clearTimeout(id);
  }, [searchTerm, commitRecentSearch]);

  return (
    <SearchContext.Provider
      value={{
        searchTerm,
        setSearchTerm,
        magazijnSubTab,
        setMagazijnSubTab,
        recentSearches,
        commitRecentSearch,
      }}
    >
      {children}
    </SearchContext.Provider>
  );
};
